import React, { useState } from "react";
import styled from "styled-components";
import { cropImageSize } from "../../../utils/functions";
import Controls from "./../../molecules/Controls";
import ModalWindow from "./../../molecules/Modal";
import { ReactComponent as EmptyMeal } from "./../../atoms/icons/excluded.svg";

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    margin: 0;
    padding: 35px 7.5px 25px 7.5px;

    &.excluded .meal-item__img,
    &.excluded .meal-item__tags, 
    &.excluded .meal-item__tags span:not(.meal-item__tags-item--excluded),
    &.excluded .meal-item__title,
    &.excluded .meal-item__icons,
    &.excluded .meal-item__controls {
        opacity: 0.3;
    }

    &:nth-child(2n + 3) {
        &::before {
            content: "";
            position: absolute;
            width: calc(100% - 15px);
            border-top: 1px solid #e6e6e6;
            transform: translate(0, -30px);
        }
    }

    @media (min-width: 540px) {
        width: 33.33%;
        padding-bottom: 40px;

        &:nth-child(2n + 3) {
            &::before {
                display: none;
            }
        }

        &:nth-child(3n + 4) {
            &::before {
                display: block;
                content: "";
                position: absolute;
                width: calc(100% - 15px);
                border-top: 1px solid #e6e6e6;
                transform: translate(0, -30px);
            }
        }
    }

    @media (min-width: 540px) {
        width: 25%;

        &:nth-child(2n + 3) {
            &::before {
                display: none;
            }
        }

        &:nth-child(3n + 4) {
            &::before {
                display: none;
            }
        }

        &:nth-child(4n + 5) {
            &::before {
                display: block;
                content: "";
                position: absolute;
                width: calc(100% - 15px);
                border-top: 1px solid #e6e6e6;
                transform: translate(0, -30px);
            }
        }
    }
`;

const ImageWrap = styled.div`
    position: relative;
    margin-bottom: 10px;
    padding: 0 7px;
    min-height: 50%;
    text-align: center;

    &:hover {
        div.img-overlay {
            opacity: 1;
            visibility: visible;
            transition: 0.3s ease all;
        }

        div:not(.img-overlay) {
            opacity: 0;
            visibility: hidden;
            transition: 0.3s ease all;
        }

        img {
            filter: brightness(50%);
            transition: 0.3s ease all;
        }
    }
`;

const Image = styled.img`
    width: 100%;
    filter: brightness(100%);
    transition: 0.3s ease all;
    border-radius: 3px;
    cursor: pointer;
`;

const ImageOverlay = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: -0.3px;
    text-align: center;
    color: #fff;
    text-align: center;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s ease all;
    cursor: pointer;

    @media (min-width: 990px) {
        line-height: 1.5;
    }
`;

const Title = styled.h3`
    margin: 4px 0 8px 0;
    font-size: 14px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: center;

    @media (min-width: 990px) {
        font-size: 20px;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: -0.38px;
        letter-spacing: -0.3px;
    }
`;

const Price = styled.div`
    margin-bottom: 30px;
    font-size: 14px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: center;
`;

export default function MealItem(props) {
    const getPrice = () => {
        return variants.length ? "$" + variants[0].price + " each" : "";
    };
    const { id, title, image, images, quantitySelected, variants } = props;
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const price = getPrice();
    const optimizedImage = cropImageSize(image, "600");

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const handleQuantityChange = (quantity) => {
        props.mealChange({
            id: props.id,
            quantity: quantity,
            title: props.title,
            image: props.image,
            variants: props.variants,
            images: props.images || [],
            handle: props.handle,
            frequence: props.frequence,
            sku: props.variants.length ? props.variants[0].sku : "",
            skuList: props.variants.length ? props.variants[0].sku + ":" + quantity : "",
            price: props.variants?.length ? props.variants[0].price : (props.price || 0),
            tags: props.tags,
            type: props.type || (props.tags?.includes('breakfast') ? 'breakfast' : 'entrée')
        });
    };

    return (
        <Wrap data-id={id}>
            <ImageWrap>
                {image.length > 0 ? (
                    <Image
                        src={optimizedImage}
                        loading="lazy" decoding="async"
                        className="meal-item__img"
                        alt={title}
                    />
                ) : (
                    <EmptyMeal />
                )}
                <ImageOverlay
                    className="img-overlay"
                    onClick={openModal}
                >
                    See Ingredients and Nutrition
                </ImageOverlay>
            </ImageWrap>
            <Title className="meal-item__title">{title}</Title>
            <Price>{price}</Price>
            <Controls
                quantityChange={handleQuantityChange}
                quantitySelected={quantitySelected}
            />
            <ModalWindow
                productId={id}
                images={images}
                modalIsOpen={modalIsOpen}
                closeModal={closeModal}
                productData={props}
                title={title}
                variants={props.variants}
            />
        </Wrap>
    );
}
